/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BcSystemDetailResponse } from '../../models/bc-system-detail-response';

export interface GetSystemDetail$Params {
  id: number;
}

export function getSystemDetail(http: HttpClient, rootUrl: string, params: GetSystemDetail$Params, context?: HttpContext): Observable<StrictHttpResponse<BcSystemDetailResponse>> {
  const rb = new RequestBuilder(rootUrl, getSystemDetail.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BcSystemDetailResponse>;
    })
  );
}

getSystemDetail.PATH = '/business-central/systems/{id}';
